import styled from 'styled-components';

export const ClaimStepperWrapper = styled.div`
  @media (min-width: 768px) {
    margin-left: 48px;
    max-width: 540px;
  }

  @media (max-width: 768px) and (min-width: 551px) {
    margin-bottom: 24px;
  }
`;
